/* @jsx jsx */
import FocusLock from 'react-focus-lock';
import { useOverlay } from '@react-aria/overlays';
import { jsx } from '@theme-ui/core';
import * as React from 'react';
import { StyleProp } from './types';

interface PopoverProps {
  popoverRef?: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
  isOpen?: boolean;
  onClose: () => void;
  sx?: StyleProp;
  targetRef?: any;
}

export function Popover(props: PopoverProps) {
  let ref = React.useRef<HTMLDivElement>(null);
  let { popoverRef = ref, isOpen, onClose, children, ...rest } = props;

  // Handle events that should cause the popup to close,
  // e.g. blur, clicking outside, or pressing the escape key.
  let { overlayProps } = useOverlay(
    {
      isOpen,
      onClose,
      shouldCloseOnBlur: true,
      isDismissable: true
    },
    popoverRef
  );

  // Add a hidden <DismissButton> component at the end of the popover
  // to allow screen reader users to dismiss the popup easily.
  return (
    <FocusLock
      returnFocus={false}
      onDeactivation={() => {
        window.setTimeout(() => {
          if (props?.targetRef?.current) {
            props?.targetRef?.current?.focus();
          }
        }, 0);
      }}
    >
      <div
        {...overlayProps}
        {...rest}
        sx={{ position: 'absolute', zIndex: 1, variant: 'layout.listbox' }}
        ref={popoverRef}
      >
        {children}
        {/* <DismissButton onDismiss={onClose} /> */}
      </div>
    </FocusLock>
  );
}
